// extracted by mini-css-extract-plugin
export var orderDetails = "_qb-2";
export var orderImage = "_qb-1";
export var orderMeta = "_qb-3";
export var orderSummary = "_qb-0";
export var rightArrow = "_qb-4";